(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.MetricTransformIds = exportFn();
        });
    }

    function exportFn() {
        return {
            deltaAbsolute: 'deltaAbsolute',
            deltaRelative: 'deltaRelative',

            companiesBenchmark: 'companiesBenchmark',
            companiesBenchmarkDeltaAbsolute: 'companiesBenchmarkDeltaAbsolute',
            companiesBenchmarkDeltaRelative: 'companiesBenchmarkDeltaRelative',

            percentOfTotal: 'percentOfTotal'
        };
    }
})();
